import {
  useElement,
  useStaleLayout,
  usePromise,
  useRect,
  useSelections,
} from "@nebula.js/stardust";
import defaults from "../tsp-output/defaults.json";
import data from "./extension/data";
import ext from "./extension/ext";
import paint from "./paint";
import type { SelectionController } from "./paint";
import type { SnWordCloudLayout } from "../tsp-output/types";

import "./styles.css";

export default function supernova() {
  return {
    qae: {
      properties: defaults,
      data: data(),
    },
    component() {
      const el = useElement();
      const layout = useStaleLayout() as SnWordCloudLayout;
      const selections = useSelections();
      const rect = useRect();

      usePromise(() => {
        const component: SelectionController = {
          beginSelections: (root) => {
            if (!selections.isActive()) {
              void selections.begin(["/qHyperCubeDef"]);
              if (root) {
                root.classList.toggle("in-selections");
              }
            }
          },
          selectValues: (dim, values, toggle) => {
            void selections.select({
              method: "selectHyperCubeValues",
              params: ["/qHyperCubeDef", dim, values, toggle],
            });
          },
        };
        return paint(el, layout, component);
      }, [el, layout, selections, rect]);
    },
    ext: ext(),
  };
}
